import { observer } from "mobx-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FORM_FIELDS,
  FREQUENCY_CONSTANTS,
  STATIC_GROUPS,
  WASTE_UNITS_1,
} from "../../../../../constants/constants";
import FormDropdown from "../../../../../components/formDropdown";
import { Accordion, Form } from "react-bootstrap";
import useStore from "../../../../../hooks/useStore";
import FormTableBody from "./formTableBody";
import { toJS } from "mobx";
import { useAuth } from "../../../../../context/authProvider";
import GlobalUnitDropDown from "../../../../../components/globalUnitDropDown";
import RecordExists from "../../../../../components/recordExists";

function AddWastePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { formData, groupsFilled, freq, formid, unitGlobal } =
    location.state || {};
  //store
  const { showAlert } = useAuth();
  const {
    userStore: { userData },
    companyStore: {
      fetchFields,
      fields,
      fetchUnits,
      companyUnit,
      kpiId,
      subCatId,
      catId,
      fetchFinancialData,
      fetchKpiTarget,
      units
    },
    wasteStore: { create },
    formStore: { recordExists, formExists, setFormExists },
  } = useStore();
  //states
  const [groupPayload, setGroupPayload] = useState([]);
  const [frequency, setFrequency] = useState({
    ...FREQUENCY_CONSTANTS,
    ...freq,
  });
  const [validate, setValidate] = useState(false);
  const [expanded, setExpanded] = useState("A");
  const [editForm, setEditForm] = useState("");
  const [globalUnit, setGlobalUnit] = useState(unitGlobal || "");

  useEffect(() => {
    fetchFields();
    fetchUnits();
  }, [fetchFields, fetchUnits]);

  useEffect(() => {
    fetchFinancialData({
      payloadData: {
        kpiId,
        subCatId,
        catId,
        year:
        frequency.frequencyYear ||
        new Date(frequency.frequencyDate).getFullYear(),
        type: "waste",
      }
    });
    fetchKpiTarget({
        payloadData: {
        kpiId,
        subCatId,
        catId,
        year:
          frequency.frequencyYear ||
          String(new Date(frequency.frequencyDate).getFullYear()),
      }
    });
}, [catId, fetchFinancialData, kpiId, subCatId, frequency.frequencyYear, frequency.frequencyDate, fetchKpiTarget]);


// useEffect(() => {
//   const groupA = groupPayload.find((e) => e.group === "A");
//   const groupB1 = groupPayload.find((e) => e.group === "B1");
//   const groupB2 = groupPayload.find((e) => e.group === "B2");
//   const groupB3 = groupPayload.find((e) => e.group === "B3");
//   const groupG = groupPayload.find((e) => e.group === "G");

//   if (!groupG || !groupA || !(groupB1 || groupB2 || groupB3)) return;

//   const safeArray = (arr) => Array.isArray(arr) ? arr : [];

//   const aPrev = safeArray(groupA?.value).reduce((acc, curr) => acc + Number(curr.prevValue || 0), 0);
//   const aTarget = safeArray(groupA?.value).reduce((acc, curr) => acc + Number(curr.target || 0), 0);
//   const bPrev = [...safeArray(groupB1?.value), ...safeArray(groupB2?.value), ...safeArray(groupB3?.value)]
//     .reduce((acc, curr) => acc + Number(curr.prevValue || 0), 0);
//   const bTarget = [...safeArray(groupB1?.value), ...safeArray(groupB2?.value), ...safeArray(groupB3?.value)]
//     .reduce((acc, curr) => acc + Number(curr.target || 0), 0);

//   const shouldCalculate = aPrev > 0 || aTarget > 0 || bPrev > 0 || bTarget > 0;
//   if (!shouldCalculate) return;

//   const calcPrev = aPrev ? ((bPrev / aPrev) * 100).toFixed(2) : "";
//   const calcTarget = aTarget ? ((bTarget / aTarget) * 100).toFixed(2) : "";

//   setGroupPayload((prev) =>
//     prev.map((ele) => {
//       if (ele.group === "G") {
//         return {
//           ...ele,
//           value: ele.value.map((v) => ({
//             ...v,
//             prevValue: calcPrev,
//             target: calcTarget,
//           })),
//           prevValue: calcPrev,
//           target: calcTarget,
//         };
//       }
//       return ele;
//     })
//   );
// }, [JSON.stringify(groupPayload)]); // forces recalculation only when payload structure changes



//   const tempGroupPayload = useMemo(
//     () =>
//       formData ||
//       Object.entries(
//         fields?.reduce(
//           (acc, curr) => ({
//             ...acc,
//             [curr.group[0]]: [
//               ...(acc[curr.group[0]] ? acc[curr.group[0]] : []),
//               { ...curr, ...FREQUENCY_CONSTANTS, ...FORM_FIELDS },
//             ],
//           }),
//           {}
//         )
//       ).map(([key, value]) => {
//         return {
//           group: key,
//           label: STATIC_GROUPS.waste[key],
//           value: value.sort((a, b) => Number(a.position) - Number(b.position)),
//           target: 0,
//           prevValue: 0,
//         };
//       }),
//     [fields, formData]
//   );


const tempGroupPayload = useMemo(
  () =>
    formData ||
    Object.entries(
      fields?.reduce((acc, curr) => {
        const groupKey = curr.group[0]; // Logical grouping e.g., "B" for "B1"
        return {
          ...acc,
          [groupKey]: [
            ...(acc[groupKey] || []),
            {
              ...curr,
              subGroup: curr.group, // ✅ full group e.g., "B1", "B2"
              ...FREQUENCY_CONSTANTS,
              ...FORM_FIELDS,
            },
          ],
        };
      }, {})
    ).map(([key, value]) => ({
      group: key,
      label: STATIC_GROUPS.waste[key],
      value: value.sort((a, b) => Number(a.position) - Number(b.position)),
      target: 0,
      prevValue: 0,
    })),
  [fields, formData]
);

useEffect(() => {
  const groupA = groupPayload.find((e) => e.group === "A");
  const groupB = groupPayload.find((e) => e.group === "B");
  const groupG = groupPayload.find((e) => e.group === "G");

  if (!groupA || !groupB || !groupG) return;

  const safeArray = (arr) => Array.isArray(arr) ? arr : [];

  const aPrev = safeArray(groupA?.value).reduce((acc, curr) => acc + Number(curr.prevValue || 0), 0);
  const aTarget = safeArray(groupA?.value).reduce((acc, curr) => acc + Number(curr.target || 0), 0);

  const b1Items = safeArray(groupB.value).filter((item) => item.subGroup === "B1");
  const b2Items = safeArray(groupB.value).filter((item) => item.subGroup === "B2");
  const b3Items = safeArray(groupB.value).filter((item) => item.subGroup === "B3");

  const bPrev = [...b1Items, ...b2Items, ...b3Items]
    .reduce((acc, curr) => acc + Number(curr.prevValue || 0), 0);
  const bTarget = [...b1Items, ...b2Items, ...b3Items]
    .reduce((acc, curr) => acc + Number(curr.target || 0), 0);

  const shouldCalculate = aPrev > 0 || aTarget > 0 || bPrev > 0 || bTarget > 0;
  if (!shouldCalculate) return;

  const calcPrev = aPrev ? ((bPrev / aPrev) * 100).toFixed(2) : "";
  const calcTarget = aTarget ? ((bTarget / aTarget) * 100).toFixed(2) : "";

  const percentUnitId = units.find((u) => u.shortName === "%")?.id;

  setGroupPayload((prev) =>
    prev.map((ele) => {
      if (ele.group === "G") {
        return {
          ...ele,
          value: ele.value.map((v) => ({
            ...v,
            prevValue: calcPrev,
            target: calcTarget,
            unit: percentUnitId, // ✅ ensure saved value uses %
            unitId: percentUnitId, // ✅ in case your backend expects unitId
          })),
          prevValue: calcPrev,
          target: calcTarget,
        };
      }
      return ele;
    })
  );
}, [JSON.stringify(groupPayload), units]);


  const allGroups = useMemo(
    () => Array.from(new Set(tempGroupPayload?.map(({ group }) => group))),
    [tempGroupPayload]
  );

  useEffect(() => {
    if (groupsFilled?.length > 0) {
      setExpanded(
        allGroups[
          allGroups.findIndex((ele) => ele === groupsFilled.slice(-1)[0]) + 1
        ]
      );
    }
  }, [allGroups, groupsFilled]);

  const dropdownValidated = useMemo(
    () =>
      (() => (frequency.frequencyType === "Daily" ? 2 : 3))() ===
      Object.values(frequency).filter((e) => e)?.length,
    [frequency]
  );

  useEffect(() => {
    setGroupPayload(tempGroupPayload);
  }, [tempGroupPayload]);

  const onCreate = useCallback(
    ({ data, frequency, groupsFilled, payload, formId, globalUnit }) => {
      create({
        data,
        companyId: Number(toJS(userData)?.companyId),
        companyUnit,
        frequency,
        kpiId,
        subCatId,
        catId,
        showAlert,
        navigate,
        totalGroups: tempGroupPayload.length,
        update: groupsFilled?.includes(data.group),
        groupData: payload,
        formId,
        setEditForm,
        globalUnit,
      });
    },
    [
      catId,
      companyUnit,
      create,
      kpiId,
      navigate,
      showAlert,
      subCatId,
      tempGroupPayload.length,
      userData,
    ]
  );

  useEffect(() => {
    setGroupPayload((prev) =>
      prev?.map((ele) => ({
        ...ele,
        value: ele?.value?.map((e) => ({ ...e, ...frequency })),
      }))
    );
  }, [frequency]);

  useEffect(() => {
    if (dropdownValidated && !formid) {
      recordExists({ frequency, type: "waste" });
    }
  }, [dropdownValidated, formid, frequency, recordExists]);

  useEffect(
    () => () => {
      setFormExists();
    },
    []
  );

  return (
    <div className="add-water-page">
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Add Waste</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/company/water">Waste List</Link>
                </li>
                <li className="breadcrumb-item active">Add Waste</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="card p-4">
        <Form validated={validate}>
          <FormDropdown
            frequency={frequency}
            setFrequency={setFrequency}
            isDisabled={groupsFilled?.length > 0}
          />
          <GlobalUnitDropDown
            setData={setGroupPayload}
            filterUnit={WASTE_UNITS_1}
            global={globalUnit}
            setGlobal={setGlobalUnit}
            disabled={!!unitGlobal}
          />
        </Form>
        {formExists ? (
          <RecordExists />
        ) : (
          <Accordion
            className="water-table-accordion"
            defaultActiveKey={"A"}
            activeKey={expanded}
            onSelect={(eventKey) => {
              setExpanded(eventKey);
              setValidate(false);
            }}
          >
            <div className="table-responsive ">
              {groupPayload?.map((data, index) => (
                <Accordion.Item
                  key={`${data.group}-accordion-item`}
                  eventKey={data.group}
                >
                  <Accordion.Header>
                    <tr style={{ display: "flex", gap: "4px" }}>
                      <td>{index + 1}</td>
                      <td colSpan={7}>{data.label}</td>
                    </tr>
                  </Accordion.Header>
                  <Accordion.Body>
                    <Form
                      noValidate
                      validated={validate}
                      onSubmit={(event) => {
                        event.preventDefault();
                        const form = event.target;
                        let freqToSend = { ...frequency };
                        let requiredFields;
                        if (freqToSend.frequencyType === "Daily") {
                          requiredFields = ["frequencyType", "frequencyDate"];
                        } else if (freqToSend.frequencyType === "Yearly") {
                          requiredFields = ["frequencyType", "frequencyYear"];
                        } else {
                          requiredFields = ["frequencyType", "frequencyYear", "frequencyMonth"];
                        }
                        const missingFields = requiredFields.filter((field) => !freqToSend[field]);
                        console.log("Missing fields:", missingFields);
                        const dropdownValid = missingFields.length === 0;
                        if (form.checkValidity() && dropdownValid) {
                          onCreate({
                            data,
                            frequency: freqToSend,
                            groupsFilled,
                            payload: groupPayload,
                            formId: formid,
                            globalUnit,
                          });
                        } else {
                          // Log invalid form fields
                          const invalidFields = [];
                          Array.from(form.elements).forEach((el) => {
                            if (el.nodeName !== "BUTTON" && !el.checkValidity()) {
                              invalidFields.push({
                                name: el.name,
                                value: el.value,
                                type: el.type,
                                validationMessage: el.validationMessage,
                              });
                            }
                          });
                          console.log("Invalid form fields:", invalidFields);
                          showAlert("Please fill All fields.");
                        }
                        setValidate(true);
                      }}
                    >
                      <table className="table align-middle table-bordered table-nowrap mb-0">
                        <thead>
                          <tr key={12} className="waterTabletr">
                            <th key={0}>Sr. No.</th>
                            <th key={1}>Title</th>
                            <th key={2}>Unit</th>
                            <th key={3}>Frequency</th>
                            <th key={4}>Current Value</th>
                            <th key={5}>Target Value</th>
                            <th key={6}>Comment</th>
                            <th key={8}>Attachment</th>
                          </tr>
                        </thead>
                        <FormTableBody
                          data={data}
                          setData={setGroupPayload}
                          frequency={frequency}
                          editForm={editForm}
                          setEditForm={setEditForm}
                          allGroups={allGroups}
                        />
                      </table>
                    </Form>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </div>
          </Accordion>
        )}
      </div>
    </div>
  );
}

export default observer(AddWastePage);
